export function buildCommentNotificationIdentity({ projectId, chatType, objectId, commentId, creatorId }) {
    return { projectId, chatType, objectId, commentId, creatorId }
}
